//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChevronRight from 'vue-material-design-icons/ChevronRight'
import TableEmptyData from '@/components/Shared/Table/TableEmptyData'

export default {
  components: { ChevronRight, TableEmptyData },
  filters: {
    fullNames(user) {
      return `${user.names} ${user.lastnames}`
    },
    projectFormatted(user) {
      // Si es solo empleado, colaborador, colaborador/supervisor
      if (user.project) {
        return user.project.name
      }
      // Si es supervisor de varios proyectos, devuelve el más reciente
      if (user?.supervisorProjects?.length > 0) {
        const orderedProjects = [...user.supervisorProjects].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
        return orderedProjects[0].name
      }
      return 'Sin proyecto'
    },
  },
  props: {
    onPageChange: {
      default: () => {},
      type: Function,
    },
  },
  methods: {
    getSkillTotal(user) {
      return user.totalSkills || 0
    },
    onRowClick(user) {
      this.$emit('click', user)
    },
    tagClass(potentialWorker) {
      return !potentialWorker.user.project &&
        potentialWorker.user?.supervisorProjects?.length === 0
        ? 'is-danger'
        : ''
    },
    isOnlySupervisor(potentialWorker) {
      return (
        !potentialWorker.user.project &&
        potentialWorker.user?.supervisorProjects?.length > 1
      )
    },
    isSupervisorCollaborator(potentialWorker) {
      return (
        potentialWorker.user.project &&
        potentialWorker.user?.supervisorProjects?.length > 0
      )
    },
    supervisorProjectLength(potentialWorker) {
      return potentialWorker?.user.supervisorProjects?.length || 0
    },
  },
}
